import { AnySourceStream, Stream, Subscription } from '../stream'

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        asPromise(): Promise<DV>
    }
}

Stream.prototype.asPromise = function <V>(this: AnySourceStream<V>) {
    return new Promise<V>((resolve, reject) => {
        const subscription: Subscription<V> = {
            value: (val: V) => {
                setTimeout(() => {
                    if (this.subscriptions.has(subscription)) {
                        this.unsubscribe(subscription)
                    }
                }, 0)
                resolve(val)
            },
            error: (err: any) => {
                setTimeout(() => {
                    if (this.subscriptions.has(subscription)) {
                        this.unsubscribe(subscription)
                    }
                }, 0)
                reject(err)
            },
        }
        this.subscribe(subscription)
    })
}
